import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdAutocompleteComponent } from './ad-autocomplete/ad-autocomplete.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [AdAutocompleteComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [AdAutocompleteComponent]
})
export class AdAutocompleteModule { }

export * from "./ad-autocomplete/ad-autocomplete.component";
export * from "./auto-complete-item";
